import Vue from 'vue'
import Vuex from 'vuex'
import map_json from '@/assets/hexagrid_only_gironde.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //url: "http://localhost:3000",
    url: "https://carteko-api.10h11.xyz",
    uid: "nefikHCzefoj186",
    user: null,
    codenaf: null,
    criteres: null,
    rdata: null,
    researches: [],
    json: {
      type: 'geojson',
      data: map_json
    },
    r_hexagons: null,
    show_profil: false
  },
  getters: {
    getUrl: state => state.url,
    getUid: state => state.uid,
    currentUser: state => state.user,
    codeNaf: state => state.codenaf,
    currentCriteres: state => state.criteres,
    rdata: state => state.data,
    hexagridSource: state => state.json,
    showProfil: state => state.show_profil,
    researches: state => state.researches
  },
  mutations: {
    goToProfile(state, data) {
      Vue.set(state, "show_profil", true)
      Vue.set(state, "researches", data)
    },
    closeProfile(state) {
      Vue.set(state, "show_profil", false)
    },
    updateUser (state, user) {
      Vue.set(state, "user", user)
      localStorage.setItem('user-' + state.uid, JSON.stringify(user))
    },
    disconnecting(state) {
      Vue.set(state, "user", null)
      Vue.set(state, "codenaf", null)
      Vue.set(state, "criteres", null)
      localStorage.removeItem('user-' + state.uid)
      localStorage.removeItem('codenaf-' + state.uid)
      localStorage.removeItem('criteres-' + state.uid)
    },
    connecting (state, data) {
      //console.log(data)
      Vue.set(state, "user", data.user)
      Vue.set(state, "codenaf", data.code_naf)
      Vue.set(state, "criteres", data.criteres)
      localStorage.setItem('user-' + state.uid, JSON.stringify(data.user))
      localStorage.setItem('codenaf-' + state.uid, JSON.stringify(data.code_naf))
      localStorage.setItem('criteres-' + state.uid, JSON.stringify(data.criteres))
      //console.log(data)
      // Vue.$http.post('https://rdataapi.10h11.xyz/carteko/', {
      //   "naf": [data.criteres.code_naf],
      //   "densi" : [data.criteres.densite],
      //   "reve" : [data.criteres.revenu],
      //   "transp": [data.criteres.transports],
      //   "fibre" : [data.criteres.fibre],
      //   "concu" : [data.criteres.concurrentes],
      //   "comple" : [data.criteres.complementaires]
      // }).then(response => {
      //   state.rdata = JSON.parse(response.data)
      // })
    },
    changeView (state, criteres) {
      Vue.set(state, "criteres", criteres)
      localStorage.setItem('criteres-' + state.uid, JSON.stringify(criteres))
      let nafs = [
        {label: "10.13B - Charcuterie", code: '10.13B'},
        {label: "10.71C - Boulangerie et boulangerie-pâtisserie", code: '10.71C'}, 
        {label: "10.71D - Pâtisserie", code: '10.71D'}, 
        {label: "41.10A - Promotion immobilière de logements", code: '41.10A'},
        {label: "41.10B - Promotion immobilière de bureaux", code: '41.10B'},
        {label: "43.32C - Agencement de lieux de vente", code: '43.32C'},
        {label: "45.11Z - Commerce de voitures et de véhicules automobiles légers", code: '45.11Z'},
        {label: "45.20A - Entretien et réparation de véhicules automobiles légers", code: '45.20A'},
        {label: "45.20B - Entretien et réparation d'autres véhicules automobiles", code: '45.20B'},
        {label: "45.32Z - Commerce de détail d'équipements automobiles", code: '45.32Z'}, 
        {label: "45.40Z - Commerce et réparation de motocycles", code: '45.40Z'},
        {label: "47.11A - Commerce de détail de produits surgelés", code: '47.11A'},
        {label: "47.11B - Commerce de d'alimentation générale", code: '47.11B'},
        {label: "47.11C - Supérettes", code: '47.11C'},
        {label: "47.11D - Supermarchés", code: '47.11D'},
        {label: "47.11E - Magasins multi-services", code: '47.11E'},
        {label: "47.19A - Grands magasins", code: '47.19A'},
        {label: "47.19B - Autres commerces de détail en magasin non spécialisé", code: '47.19B'},
        {label: "47.21Z - Commerce de détail de fruits et légumes en magasin spécialisé", code: '47.21Z'},
        {label: "47.22Z - Commerce de détail de viandes et de produits à base de viande en magasin spécialisé", code: '47.22Z'},
        {label: "47.23Z - Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé", code: '47.23Z'},
        {label: "47.24Z - Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé", code: '47.24Z'},
        {label: "47.25Z - Commerce de détail de boissons en magasin spécialisé", code: '47.25Z'},
        {label: "47.26Z - Commerce de détail de produits à base de tabac en magasin spécialisé", code: '47.26Z'},
        {label: "47.29Z - Autres commerces de détail alimentaires en magasin spécialisé", code: '47.29Z'},
        {label: "47.30Z - Commerce de détail de carburants en magasin spécialisé", code: '47.30Z'},
        {label: "47.41Z - Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé", code: '47.41Z'},
        {label: "47.42Z - Commerce de détail de matériels de télécommunication en magasin spécialisé", code: '47.42Z'},
        {label: "47.43Z - Commerce de détail de matériels audio et vidéo en magasin spécialisé", code: '47.43Z'},
        {label: "47.51Z - Commerce de détail de textiles en magasin spécialisé", code: '47.51Z'},
        {label: "47.52A - Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m²)", code: '47.52A'},
        {label: "47.52B - Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m² et plus)", code: '47.52B'},
        {label: "47.53Z - Commerce de détail de tapis, moquettes et revêtements de murs et sols en magasin spécialisé", code: '47.53Z'},
        {label: "47.54Z - Commerce de détail d'appareils électroménagers en magasin spécialisé", code: '47.54Z'},
        {label: "47.59A - Commerce de détail de meubles", code: '47.59A'},
        {label: "47.59B - Commerce de détail d'autres équipements du foyer", code: '47.59B'},
        {label: "47.61Z - Commerce de détail de livres en magasin spécialisé", code: '47.61Z'},
        {label: "47.62Z - Commerce de détail de journaux et papeterie en magasin spécialisé", code: '47.62Z'},
        {label: "47.63Z - Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé", code: '47.63Z'},
        {label: "47.64Z - Commerce de détail d'articles de sport en magasin spécialisé", code: '47.64Z'},
        {label: "47.65Z - Commerce de détail de jeux et jouets en magasin spécialisé", code: '47.65Z'},
        {label: "47.71Z - Commerce de détail d'habillement en magasin spécialisé", code: '47.71Z'},
        {label: "47.72A - Commerce de détail de la chaussure", code: '47.72A'},
        {label: "47.72B - Commerce de détail de la maroquinerie et d'articles de voyage", code: '47.72B'},
        {label: "47.73Z - Commerce de détail de produits pharmaceutiques en magasin spécialisé", code: '47.73Z'},
        {label: "47.74Z - Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé", code: '47.74Z'},
        {label: "47.75Z - Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé", code: '47.75Z'},
        {label: "47.76Z - Commerce de détail de fleurs, plantes, graines, engrais, animaux en spécialisé", code: '47.76Z'},
        {label: "47.77Z - Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé", code: '47.77Z'},
        {label: "47.78A - Commerces de détail d'optique", code: '47.78A'},
        {label: "49.42Z - Servies de déménagement", code: '49.42Z'},
        {label: "52.29A - Messagerie, fret express", code: '52.29A'},
        {label: "55.10Z - Hôtels et hébergement similaire", code: '55.10Z'},
        {label: "56.10A - Restauration traditionnelle", code: '56.10A'}, 
        {label: "56.10B - Cafétérias et autres libres-services", code: '56.10B'},
        {label: "56.10C - Restauration de type rapide", code: '56.10C'},
        {label: "56.30Z - Débits de boissons", code: '56.30Z'},
        {label: "62.02A - Conseils en systèmes et logiciels informatiques", code: '62.02A'},
        {label: "68.31Z - Agences immobilières", code: '68.31Z'},
        {label: "69.10Z - Activités juridiques", code: '69.10Z'},
        {label: "69.20Z - Activités comptables", code: '69.20Z'},
        {label: "70.22Z - Conseils pour les affaires et la gestion", code: '70.22Z'},
        {label: "71.11Z - Activités d'architectures", code: '71.11Z'},
        {label: "73.11Z - Agences de pub", code: '73.11Z'},
        {label: "82.11Z - Services administratifs combinés de bureau", code: '82.11Z'},
        {label: "86.21Z - Activité des médecins généralistes", code: '86.21Z'},
        {label: "93.19Z - Autres activités liées au sport", code: '93.19Z'},
        {label: "96.01B - Blanchisserie-teinturerie de détail", code: '96.01B'},
        {label: "96.02A - Coiffure", code: '96.02A'},
        {label: "96.02B. - Soins de beauté", code: '96.02B'}
      ]
      nafs.map(naf => {
        if (naf.code == criteres.code_naf) {
          Vue.set(state, "codenaf", naf)
          localStorage.setItem('codenaf-' + state.uid, JSON.stringify(naf))
        }
      })
    },
    completeHexagrid (state, data) {
      let new_json = state.json.data
      new_json.features.map((feature, index) => {
        let id = feature.properties.id
        //
        // FROM R DATA
        // a => removed : id de la zone (int)
        // b => removed : longitude du centre de la zone (float)
        // c => removed : latitude du centre de la zone (float)
        // d => g (g by geojson) => removed : 1 si l'hexagone appartient à la Gironde, 0 autrement (int)
        // e => c (c by geojson) : liste des communes touchées par la zone (char)
        // f => a => d : densité population hexagone en habs/km2 (int)
        // g => b => r : mediane des revenus hexagone (euros) (int)
        // h => c => p : prix moyen surface au m2 (euros) (int)
        // i => d => a : nombre d'arrets de bus/tram dans l'hexagone (int)
        // j => e => b : nombre d'arrets de bus/tram dans les 6 hexagones voisins (int)
        // k => f => h : nombre d'ecoles dans l'hexagone (int)
        // l => g => i : nombre d'ecoles dans les 6 hexagones voisins (int)
        // m => h => f : taux de couverture par la fibre dans l'hexagone (float)
        // n => i => k : nombre de boites concurrentes dans l'hexagone (int)
        // o => j => l : nombre de boites concurrentes dans les 6 hexagones voisins (int)
        // p => k => m : nombre de boites complementaires dans l'hexagone (int)
        // q => l => n : nombre de boites complementaires dans les 6 hexagones voisins (int)
        // r => m => s : score global de l'hexagone (note sur 10) (float)
        //
        new_json.features[index].properties.d = data.a[id - 1] // densité
        new_json.features[index].properties.r = data.b[id - 1] // revenus
        new_json.features[index].properties.p = data.c[id - 1] // prix surface
        new_json.features[index].properties.a = data.d[id - 1] // arrêts
        new_json.features[index].properties.b = data.e[id - 1] // arrêts voisins
        new_json.features[index].properties.h = data.f[id - 1] // ecoles
        new_json.features[index].properties.i = data.g[id - 1] // ecoles voisins
        new_json.features[index].properties.f = data.h[id - 1] // fibre
        new_json.features[index].properties.k = data.i[id - 1] // concurrentes
        new_json.features[index].properties.l = data.j[id - 1] // concurrentes voisins
        new_json.features[index].properties.m = data.k[id - 1] // complementaires
        new_json.features[index].properties.n = data.l[id - 1] // complementaires voisins
        new_json.features[index].properties.s = data.m[id - 1] // score
      })
      state.json = {
        type: 'geojson',
        data: new_json
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
